import Vue from 'vue';
import Vuex, {Store} from 'vuex';
//import appFilters from "@/store/modules/appFilters";
Vue.use(Vuex);

interface appFilterItem {
    source:string;
    filters:Array<any>
}

export interface IState {
    salon_id: number | string | null;
    selected: boolean;
}

export type IStore = Store<IState>;

const store = new Vuex.Store<IState>({
    state: {
        salon_id: sessionStorage.getItem('salon_id') ?? 0,
        selected: false
    },
    getters: {
    },
    mutations: {
        changeSalon (state, salon_id) {
            sessionStorage.setItem('salon_id', salon_id);
            state.salon_id = salon_id;
            if(!state.selected)
            {
                state.selected = true;
            }
        }
    },
    /*modules:{
        appFilters
    }*/
});

export default store;
